import React from 'react';
import { useParams } from 'react-router-dom';

// Full-screen renderer for the self-hosted projectorstream.com page clones
// (served from public/*.html). Used for client demos. CSS/JS/images load from
// the projectorstream.com CDN. The optional :code route param is forwarded to
// the clone via ?code=… so its buttons can deep-link into our app:
//   /home/:code  → Login/Get Started → /referral/:code, Gift → /gift2/:code
//   /gift2/:code → Gift → /gift/:code
export const ProjectorStreamHome = ({ src = '/home-clone.html', title = 'Projector Stream' }) => {
  const { code } = useParams();
  const finalSrc = code ? `${src}?code=${encodeURIComponent(code)}` : src;
  return (
    <iframe
      title={title}
      src={finalSrc}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
      }}
    />
  );
};

export default ProjectorStreamHome;
